import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogOverlay,
  Box,
  Button,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import React from 'react';
import { useDispatch } from 'react-redux';
import { GetLocationId } from 'reactRedux/thunks/merchnatThunk/merchantThunk';
import PropTypes from 'prop-types';
import { MdAddLocationAlt } from 'react-icons/md';

const GenerateLocationConfirmModal = ({
  showModal,
  setShowModal,
  setValue,
  editmerchantId,
  setTempLocationId,
}) => {
  const { onClose } = useDisclosure();
  const dispatch = useDispatch();

  const onConfirm = () => {
    dispatch(
      GetLocationId({ merchantId: Number(editmerchantId) }, (response) => {
        setValue('locationId', response?.locationId || '');
        setTempLocationId(response?.locationId || '');
      }),
    );
    setShowModal(false);
  };

  return (
    <>
      {showModal && (
        <>
          <AlertDialog isOpen={showModal} onClose={onClose} isCentered>
            <AlertDialogOverlay>
              <AlertDialogContent
                maxWidth="400px"
                borderRadius="lg"
                boxShadow="lg"
                p={4}
              >
                <AlertDialogBody
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  py={6}
                >
                  <Box
                    as={MdAddLocationAlt}
                    size={80}
                    color={'primary.500'}
                    mb={4}
                  />
                  <Text
                    fontSize="18px"
                    fontWeight="medium"
                    textAlign="center"
                    mt={5}
                  >
                    Are you sure you want to generate a new Location ID?
                  </Text>
                </AlertDialogBody>
                <AlertDialogFooter justifyContent="center">
                  <Button
                    variant="outline"
                    onClick={() => setShowModal(false)}
                    padding="10px 20px"
                    mr={4}
                  >
                    Cancel
                  </Button>
                  <Button
                    bg="primary"
                    color="white"
                    _hover={{ bg: 'primary', opacity: 0.8 }}
                    onClick={() => onConfirm()}
                    padding="10px 20px"
                  >
                    Generate
                  </Button>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialogOverlay>
          </AlertDialog>
        </>
      )}
    </>
  );
};

GenerateLocationConfirmModal.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  setValue: PropTypes.func,
  editmerchantId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setTempLocationId: PropTypes.func,
};

export default GenerateLocationConfirmModal;
